import Vue from 'vue'
import Vuex from 'vuex'
import froalaconfig from './modules/froalaconfig'
import board from './modules/board'
import cockpit from './modules/cockpit'
import user from './modules/user'
import router from './modules/router';
import newsletter from './modules/newsletter';
import organizations from './modules/organizations'
import teams from './modules/teams'
import portfolio from './modules/portfolio'


//import Cockpitsapi from '@/services/api/cockpits'
//const CryptoJS = require("crypto-js");

Vue.use(Vuex)
Vue.config.devtools = true

const store = new Vuex.Store({
  state: {
    errpages: ['/400', '/401', '/402', '/403', '/404', '/405'],
    whiteListAuth: ['/apitoken','/','/set-password','ssosignin','/ssosignout','/sign-in-sso','/sign-out-sso','/sign-in-relay','/sign-in','/sign-up','/forgot-password','/forgot-password/','/password-reset','/password-reset/', '/email-change', '/email-change/','/tools-pages','/sign-out', '/registration/', '/registration', '/profiler','/avatarimages','/boards','/projects','/my/boards'], 
    whiteList: ['/apitoken','/','/set-password','ssosignin','/ssosignout','/sign-in-sso','/sign-out-sso','/sign-in-relay','/sign-in','/sign-up','/forgot-password','/forgot-password/','/password-reset','/password-reset/', '/email-change', '/email-change/', '/tools-pages','/sign-out', '/registration/', '/registration', '/profiler','/avatarimages','/boards','/projects','/my/boards'],
    screenType:'',
    screenSize:'',
    deviseType:navigator.userAgent,
    browsertype:navigator.appVersion,
    isMobile: /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ? true : false,
    hasTouch: /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ? false : true,
    showhints:false,
    forceRefresh:0,
    s3auth:{"":""}
  },
  mutations: {
    UPDATE_FORCEREFRESH(state){
    state.forceRefresh++
    },
    SET_SCREENTYPE(state,type){
    state.screenType = type
    },
    SET_DEVISETYPE(state, type){
    state.deviseType = type
    },
    SET_SCREENSIZE(state, size){
    state.screenSize = size
    },
    SET_SHOWHINTS(state,showhints){
    state.showhints = showhints

    },
    SET_S3AUTH(state,s3auth){



      state.s3auth = s3auth
    }
  },
  actions: {
    SET_SCREENTYPE({commit},data){
      commit('SET_SCREENTYPE',data)
    },
     SET_DEVISETYPE({commit},data){
      commit('SET_DEVISETYPE',data)
    },
     SET_SCREENSIZE({commit},data){
      commit('SET_SCREENSIZE',data)
    },
    GET_S3AUTH({commit}, data ){

      commit('SET_S3AUTH', data )

      
    },

    fetchS3credentials(){

      //{commit}
      return false



      // function decryptString($string) {
      //   var Utf8 = CryptoJS.enc.Utf8;
      //   const $secret_key='MS29dT7EBzKqxHprCfbs6n';
      //   const $secret_iv='v2tpur7GkBNadPwjyb5mUM';
      //   const key= CryptoJS.SHA256($secret_key).toString(CryptoJS.enc.Hex).substring(0,32);
      //   let iv= CryptoJS.SHA256($secret_iv).toString(CryptoJS.enc.Hex).substring(0,16);
      //   const encrypt = CryptoJS.enc.Base64.parse($string).toString(CryptoJS.enc.Utf8);
      //   const decrypt = CryptoJS.AES.decrypt(encrypt, Utf8.parse(key), { iv: Utf8.parse(iv)}).toString(Utf8);
      //   return decrypt;
      // }


      // Cockpitsapi.Apis().then( function( response ){

      //    commit('SET_S3AUTH', {"cc": decryptString(response.data.cc), "dd":decryptString(response.data.dd) } )

      // })


      
    },

    


  },
  getters:{
    get_routes: state => { 
      var routers = []
      routers.push.apply(routers, state.whiteListAuth)
      routers.push.apply(routers, state.errpages)
      return routers
    },
   
  },
  modules: {
    config: froalaconfig,
    board: board,
    cockpit: cockpit,
    user:user,
    router: router,
    newsletter:newsletter,
    organizations: organizations,
    teams: teams,
    portfolio: portfolio
  }
})

// window.addEventListener("resize", function(){
//     var h = window.$(froala['$box'])[0].clientWidth

//     if(h >= 600){
//       store.state.config.toolbarButtons = toolbarButtonsBig
//     } else{
//       console.log('froala height 600',  store.state.config.toolbarButtons)

//       store.state.config.toolbarButtons  = toolbarButtonsMini
//     }
//  });


export default store
